import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { Provider, Store } from 'react-redux';

import { FormWrapperComponent as FormWrapper } from '../../components/FormWrapper/FormWrapperComponent';
import { NewVerificationComponent } from '../../components/NewVerificationComponent';

import { DatabaseId, ReduxState } from '../../lib/types/types';
import { assertValidProgramId } from '../../lib/types/assertions';
import { getStore } from '../../lib/VerificationService/VerificationServiceStore';


interface VerificationFormProps {
    programId: DatabaseId;
    trackingId?: string;
}

const store: Store<ReduxState> = getStore();

export const VerificationForm = ({ programId, trackingId }: VerificationFormProps) => {
    assertValidProgramId(programId);
    store.dispatch({ programId, type: 'PROGRAM_ID' });

    return (
        <Provider store={store}>
            <FormWrapper>
                {<NewVerificationComponent programId={programId} trackingId={trackingId} />}
            </FormWrapper>
        </Provider>
    );
};
